import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { LocalStorageUtils } from './../../utils/localstorage';
import { environment } from './../../../environments/environment';
export abstract class BaseService {
  private readonly _key = 'y4z80WFiwJ52hK3LWU0ym6v5HvWKq0X98qsINLj2';
  private readonly _key_Auth = 'QfhRXvmTEZHl6yRfrjQe83bazSWPEzqNggMi72pq-fHYfO0PL73KoTX89Z01S4vRHKlNajU-5CUT1z0QbzRbnw';
  public LocalStorage = new LocalStorageUtils();
  protected UrlService: string = environment.urlBase;
  protected UrlServiceEmailSms: string = environment.urlApiEmailSms;
  protected UrlAuth: string = environment.urlApiAuth;
  protected CepGateway: string = environment.cepGateway;

  protected httpOptionsFormData() {
    return {
      headers: new HttpHeaders({
        'x-api-key': this._key,
      }),
    }
  };

  protected obterHeaderJsonSimples() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  protected obterHeaderJsonXAPI() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': this._key_Auth,
      }),
    };
  }

  protected obterHeaderJson() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': this._key,
      }),
    };
  }

  protected obterHeaderJsonToken() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': this._key,
        Authorization: `Bearer ${this.LocalStorage.obterToken()}`,
      }),
    };
  }

  protected obterHeaderJsonTokenParans(token: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': this._key,
        Authorization: `Bearer ${token}`,
      }),
    };
  }

  protected obterHeaderJsonComToken(token: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': this._key,
        Authorization: `Bearer ${token}`,
      }),
    };
  }

  protected obterHeaderJsonWithToken(token: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': this._key,
        Authorization: `Bearer ${token}`,
      }),
    };
  }

  protected obterHeaderJsonTokenSap(token: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
    };
  }

  protected obterHeaderJsonTokenComReportProgress() {
    return {
      headers: new HttpHeaders({
        'x-api-key': this._key,
        Authorization: `Bearer ${this.LocalStorage.obterToken()}`,
      }),
      reportProgress: true,
    };
  }

  protected extractData(response: any) {
    return response || {};
  }

  protected serviceError(response: Response | any) {
    let customError: string[] = [];

    if (response instanceof HttpErrorResponse) {
      if (response.statusText === 'Unknown Error') {
        customError.push('Ocorreu um erro desconhecido');
      }
    }

    return throwError(response);
  }
}
